module.exports = __webpack_public_path__ + "static/media/start-conversion.2064402c.jpg";